import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { MenuOptions } from './MenuOptions';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem } from './MenuItem';
import { Button } from '@mui/material';
import { api } from 'common';

const drawerWidth = 240;

const openedMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const hoveredMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  position: 'absolute',
  height: '100vh',
});

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(6)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  backgroundColor: '#fff',
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // ...(open && {
  //   width: `calc(100% - ${drawerWidth}px)`,
  //   marginLeft: drawerWidth,
  //   transition: theme.transitions.create(['width', 'margin'], {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  // }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  // ...(open && {
  //   ...openedMixin(theme),
  //   '& .MuiDrawer-paper': openedMixin(theme),
  // }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
  // ...(!open && {
  //   '&:hover': {
  //     ...hoveredMixin(theme),
  //     '& .MuiDrawer-paper': hoveredMixin(theme),
  //   },
  // }),
}));

const MenuComponent = ({ children }) => {
  const auth = useSelector(state => state.auth);
  const options = MenuOptions();
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const { signOff } = api;
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    setMenuItems(options.filter(item => item.access.includes(role)));
  }, [role]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const LogOut = () => {
    dispatch(signOff());
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" open={false}>
        <Toolbar>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <img
              style={{
                width: '3rem',
                height: '3rem',
              }}
              src={require('../../assets/img/logo192x192.png')}
              alt="Logo"
            />
            <div>
              <Button onClick={LogOut} startIcon={<LogoutIcon />}>
                {'Cerrar sesión'}
              </Button>
            </div>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={false}>
        <DrawerHeader></DrawerHeader>
        <Divider />

        <List>
          <div>
            {menuItems.map(item => (
              <MenuItem item={item} key={item} />
            ))}
          </div>
          <img
            src={auth.profile.profile_image}
            alt="imagen de perfil"
            style={{
              width: '100%',
            }}
          />
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 6 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};

export default MenuComponent;
